import { connect } from 'react-redux';

import CognitoFormForm from '../components/CognitoFormForm';
import { createCognitoFormSkip } from '../../../../../state/modules/cognitoFormAnswers/actions';

const mapStateToProps = (state, ownProps) => {
  const profileId = state.session.get('profileId');

  return { profileId };
};

const mapDispatchToProps = (dispatch) => {
  return {
    create: (careGuideId, data, cb) => {
      dispatch(createCognitoFormSkip(careGuideId, data, cb));
    },
  };
};

const CognitoFormFormContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(CognitoFormForm);

export default CognitoFormFormContainer;
